import { render, staticRenderFns } from "./AllInvestigations.vue?vue&type=template&id=0a106ef6&"
import script from "./AllInvestigations.vue?vue&type=script&lang=ts&"
export * from "./AllInvestigations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a106ef6')) {
      api.createRecord('0a106ef6', component.options)
    } else {
      api.reload('0a106ef6', component.options)
    }
    module.hot.accept("./AllInvestigations.vue?vue&type=template&id=0a106ef6&", function () {
      api.rerender('0a106ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/AllInvestigations.vue"
export default component.exports